import { ReactNode } from "react";

interface StandardSectionProps {
  children: ReactNode;
  className?: string;
  background?: "white" | "light" | "gradient";
  id?: string;
}

export default function StandardSection({ 
  children, 
  className = "", 
  background = "white",
  id 
}: StandardSectionProps) {
  const getBackgroundClass = () => {
    switch (background) {
      case "light":
        return "bg-gray-50";
      case "gradient":
        return "bg-gradient-to-br from-gray-50 to-white";
      default:
        return "bg-white";
    }
  };

  return (
    <section 
      id={id}
      className={`py-20 ${getBackgroundClass()} relative overflow-hidden ${className}`}
    >
      {/* Subtle background pattern */}
      <div 
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%2310b981' fill-opacity='0.3'%3E%3Cpath d='M30 30h30v30H30z'/%3E%3C/g%3E%3C/svg%3E")`
        }}
      />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {children}
      </div>
    </section>
  );
}